var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-row',{staticClass:"add-card-page-wraper"},[(_vm.addCardUrl)?[_c('div',{staticClass:"iframe-container"},[_c('iframe',{ref:"renderAddCard",staticClass:"add-card-page",attrs:{"src":_vm.addCardUrl,"allowpaymentrequest":""}})])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }